/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMatchTimelineDtoSchema } from "./goodLuck/core/DTOs/matchTimelineDtoSchema.ts";
import { z } from "zod/v4";

export const getBracketsMatchesMatchidTimelinePathParamsSchema = z.object({
  matchId: z.string(),
});

/**
 * @description OK
 */
export const getBracketsMatchesMatchidTimeline200Schema = z.lazy(
  () => goodLuckCoreDTOsMatchTimelineDtoSchema,
);

export const getBracketsMatchesMatchidTimelineQueryResponseSchema =
  getBracketsMatchesMatchidTimeline200Schema;
